import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const echo = () => call(websocketFetch, 'echo');
